import { Stack, Typography } from '@mui/material';
import { PriceTypes } from '@/models/catalog/course';
import type { Installment } from '@/models/catalog/offer';
import { calculateInstallmentValue } from '@/packages/courses/components/prices/utils';
import { formatMoney } from '@/utils/format-money';

interface OriginalPriceProps {
  hasKnownPrice: boolean;
  originalPrice: number | null;
  type: PriceTypes;
  installment: Installment | null;
}

export const OriginalPrice = ({
  hasKnownPrice,
  originalPrice,
  type,
  installment,
}: OriginalPriceProps) => {
  if (!hasKnownPrice || !originalPrice || originalPrice <= 0) return null;

  if (type === PriceTypes.OneOff) {
    return (
      <Typography component="div">
        <Stack spacing={0.5} direction="row">
          <span>De</span>
          <Typography component="span" sx={{ textDecoration: 'line-through' }}>
            <span>{formatMoney(originalPrice)} </span>
            {installment && (
              <>
                <span>ou </span>
                <span>{installment.max}x </span>
                <span>
                  {formatMoney(
                    calculateInstallmentValue(originalPrice, installment)
                  )}
                </span>
              </>
            )}
          </Typography>
        </Stack>
      </Typography>
    );
  }

  if (type === PriceTypes.Tuition) {
    return (
      <Typography
        component="div"
        sx={(theme) => ({
          textDecoration: 'line-through',
          '&& *': {
            fontSize: theme.typography.body2.fontSize,
            lineHeight: theme.typography.caption.lineHeight,
          },
        })}
      >
        {installment && <span>{installment.max}x </span>}
        <span>
          {installment
            ? formatMoney(calculateInstallmentValue(originalPrice, installment))
            : formatMoney(originalPrice)}
        </span>
        <span> /Mês</span>
      </Typography>
    );
  }

  return null;
};
